import { render, staticRenderFns } from "./CitorSurvey.vue?vue&type=template&id=19dfde21"
import script from "./CitorSurvey.vue?vue&type=script&lang=ts"
export * from "./CitorSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports